import {NgModule} from '@angular/core';
import {Surface3dIconsComponent} from './Icons/surface3d-icons.component';
import {MaterialDesignModule} from './MaterialDesign/material-design.module';


@NgModule({
    declarations: [Surface3dIconsComponent],
    imports: [
        MaterialDesignModule
    ],
    exports: [Surface3dIconsComponent, MaterialDesignModule]
})
export class Surface3dDesignModule {
}
